import type { DividerDesignTokens } from '@primeuix/themes/types/divider'

export default {
  root: {
    borderColor: '{content.border.color}',
  },
  content: {
    color: '{text.color}',
    background: '{content.background}',
  },
  vertical: {
    margin: '0 1.125rem',
    content: {
      padding: '0.625rem 0',
    },
    padding: '1.125rem 0',
  },
  horizontal: {
    margin: '1.125rem 0',
    content: {
      padding: '0 0.625rem',
    },
    padding: '0 1.125rem',
  },
} satisfies DividerDesignTokens
